import { AxiosResponse } from "axios";
import { APIClient } from "../axiosClient";
import { PaginationResponse, ResponseData } from "../types/_public";
import { IKeywordSearch } from "../types/newshub/_keyword";
import { PATH_NEWSHUB_API } from "helpers/newshub/constans";
const api = new APIClient();

const path_keywords = PATH_NEWSHUB_API + '/keywords';

const userApi = {
  keywords(params: any): Promise<AxiosResponse<ResponseData<IKeywordSearch[]> & PaginationResponse, any>> {
    const url = `${path_keywords}`
    return api.get(url, params)
  },
  searchKeyword(params: any = {}): Promise<AxiosResponse<ResponseData<IKeywordSearch>, any>> {
    const url = `${path_keywords}/search`;
    return api.get(url, params)
  },
}
export default userApi
